import { useEffect } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getHospitalById, subscribeToHospitalConfig } from '../services/cloudflareService';

export const useHospitalSync = (hospitalId: string | undefined | null) => {
    const queryClient = useQueryClient();

    const query = useQuery({
        queryKey: ['hospital', hospitalId],
        queryFn: () => hospitalId ? getHospitalById(hospitalId) : null,
        enabled: !!hospitalId,
    });

    useEffect(() => {
        if (!hospitalId) return;

        const unsubscribe = subscribeToHospitalConfig(hospitalId, (updatedHospital) => {
            if (updatedHospital) {
                queryClient.setQueryData(['hospital', hospitalId], updatedHospital);
            }
        });

        return () => {
            unsubscribe();
        };
    }, [hospitalId, queryClient]);

    return query;
};
